/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Businessnamerequired2Inputs */

const en_businessnamerequired2 = /** @type {(inputs: Businessnamerequired2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business name is required`)
};

const de_businessnamerequired2 = /** @type {(inputs: Businessnamerequired2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firmenname ist erforderlich`)
};

/**
* | output |
* | --- |
* | "Business name is required" |
*
* @param {Businessnamerequired2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const businessnamerequired2 = /** @type {((inputs?: Businessnamerequired2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Businessnamerequired2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_businessnamerequired2(inputs)
	return de_businessnamerequired2(inputs)
});
export { businessnamerequired2 as "businessNameRequired" }